import { createAction } from 'redux-actions';
import { createCallbackActionCreator } from '../../Stream/helpers';
import { actionTypePrefix } from './constants';
export var blockUser = createAction("".concat(actionTypePrefix, ".BLOCK_USER"), function (user) { return ({ user: user }); });
export var blockUserAndRedirect = createAction("".concat(actionTypePrefix, ".BLOCK_USER_AND_REDIRECT"), function (user, redirectLocation) { return ({
    user: user,
    redirectLocation: redirectLocation,
}); });
export var blockUserSuccess = createAction("".concat(actionTypePrefix, ".BLOCK_USER_SUCCESS"), function (userId) { return userId; });
export var blockUserFail = createAction("".concat(actionTypePrefix, ".BLOCK_USER_FAIL"), function (user, result) { return ({ user: user, result: result }); });
export var unblockUser = createAction("".concat(actionTypePrefix, ".UNBLOCK_USER"), function (userId) { return userId; });
export var unblockUserSuccess = createAction("".concat(actionTypePrefix, ".UNBLOCK_USER_SUCCESS"), function (userId) { return userId; });
export var unblockUserFail = createAction("".concat(actionTypePrefix, ".UNBLOCK_USER_FAIL"), function (userId) { return userId; }, function (userId, result) { return result; });
export var searchFriendsWithOptions = createAction("".concat(actionTypePrefix, ".SEARCH_FRIENDS"), function (query, callback, options) {
    var _a, _b;
    return ({
        query: query,
        callback: callback,
        isChatContext: options.isChatContext,
        includeNonFriendExactMatch: (_a = options.includeNonFriendExactMatch) !== null && _a !== void 0 ? _a : true,
        userType: (_b = options.userType) !== null && _b !== void 0 ? _b : 'both',
    });
});
export var searchFriends = function (query, callback) {
    return searchFriendsWithOptions(query, callback, {
        includeNonFriendExactMatch: false,
        userType: 'deviant',
    });
};
export var initializeFriendList = createAction("".concat(actionTypePrefix, ".FRIENDS_INIT"), function () { return ({}); });
export var fetchMoreFriends = createCallbackActionCreator("".concat(actionTypePrefix, ".FETCH_FRIENDS"));
//# sourceMappingURL=actionCreators.js.map